/* global Modalytics */
/**
 * Track invalid fields in HEAP
 * @param {String} invalidFieldName - invalid field name
 **/
export function trackInvalidFieldsInHeap(invalidFieldName) {
	Modalytics.heap('track', ['Validation Error | ' + invalidFieldName, {}]);
}
